import React, { useState } from "react";
import PhoneNumberInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { T } from "./ContactShared";

export function PhoneInputField({
    label,
    name,
    value,
    onChange,
    placeholder = "+60 12-3456 7890",
    required,
    error,
    defaultCountry = "MY",
}) {
    const [focused, setFocused] = useState(false);
    const borderColor = error ? T.danger : focused ? T.accent : T.border;

    const handleChange = (val) => {
        onChange({ target: { name, value: val || "" } });
    };

    const handleBlur = () => {
        setFocused(false);
    };

    return (
        <div style={{ marginBottom: 14 }}>
            <label style={{
                display: "block",
                fontSize: 11,
                fontWeight: 600,
                color: T.textMuted,
                marginBottom: 5,
            }}>
                {label}
                {required && <span style={{ color: T.danger }}> *</span>}
            </label>
            <PhoneNumberInput
                international
                countryCallingCodeEditable={false}
                defaultCountry={defaultCountry}
                value={value || undefined}
                onChange={handleChange}
                onFocus={() => setFocused(true)}
                onBlur={handleBlur}
                placeholder={placeholder}
                style={{
                    width: "100%",
                    height: 36,
                    padding: "0 11px",
                    fontSize: 13,
                    color: T.textPrimary,
                    background: "#fff",
                    fontFamily: "inherit",
                    border: `1.5px solid ${borderColor}`,
                    borderRadius: T.radiusSm,
                    outline: "none",
                    boxShadow: focused && !error ? "0 0 0 3px rgba(37,99,235,0.10)" : "none",
                    transition: "border-color 0.15s, box-shadow 0.15s",
                    boxSizing: "border-box",
                }}
            />
            {error && <div style={{ fontSize: 11, color: T.danger, marginTop: 4 }}>{error}</div>}
        </div>
    );
}